/**
 * Page Views Control Component
 * 
 * Controls display based on number of page views in session
 * 
 * @package TopBuddy
 */

import { ToggleControl, SelectControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import ProBadge from '../ProBadge';

const PageViewsControl = ({ enabled, operator, count, onEnabledChange, onOperatorChange, onCountChange }) => {
	const postSettingsData = window.topbuddyPostSettings || {};
	const isProActive = postSettingsData.isProActive || false;
	const upgradeUrl = postSettingsData.upgradeUrl || 'https://wptopbuddy.com/?utm_source=plugin&utm_medium=topbuddy-free-plugin&utm_campaign=topbuddy-free-plugin-admin';

	return (
		<div className="topbuddy-display-rules__field">
			<ToggleControl
				label={
					<>
						{__('Page Views', 'topbuddy')}
						{!isProActive && <ProBadge upgradeUrl={upgradeUrl} />}
					</>
				}
				help={__('Show notification based on number of pages viewed in current session', 'topbuddy')}
				checked={enabled}
				onChange={onEnabledChange}
				disabled={!isProActive}
				__nextHasNoMarginBottom
			/>
			
			{enabled && isProActive && (
				<div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
					<SelectControl
						value={operator}
						onChange={onOperatorChange}
						options={[
							{ label: __('Equal to', 'topbuddy'), value: 'equal_to' },
							{ label: __('Greater than', 'topbuddy'), value: 'greater_than' },
							{ label: __('Less than', 'topbuddy'), value: 'less_than' },
						]}
						style={{ flex: '0 0 140px' }}
						__next40pxDefaultSize
						__nextHasNoMarginBottom
					/>
					<NumberControl
						value={count}
						onChange={onCountChange}
						min={1}
						placeholder={__('Number of pages', 'topbuddy')}
						style={{ flex: 1 }}
						__next40pxDefaultSize
					/>
				</div>
			)}
		</div>
	);
};

export default PageViewsControl;
